var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        id: "Layer_1",
        "data-name": "Layer 1",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 120 120",
        width: "100%",
        height: "100%",
      },
    },
    [
      _c("defs", [
        _c("clipPath", { attrs: { id: "clippath-4" } }, [
          _c("circle", {
            staticClass: "blog-cls-1",
            attrs: { cx: "25.61", cy: "54.57", r: "4.73" },
          }),
        ]),
        _vm._v(" "),
        _c("clipPath", { attrs: { id: "clippath-5" } }, [
          _c("circle", {
            staticClass: "blog-cls-1",
            attrs: { cx: "30.52", cy: "58.28", r: "3.65" },
          }),
        ]),
        _vm._v(" "),
        _c("clipPath", { attrs: { id: "clippath-6" } }, [
          _c("circle", {
            staticClass: "blog-cls-1",
            attrs: { cx: "21.58", cy: "60.74", r: "2.9" },
          }),
        ]),
        _vm._v(" "),
        _c("clipPath", { attrs: { id: "clippath-7" } }, [
          _c("circle", {
            staticClass: "blog-cls-1",
            attrs: { cx: "95.29", cy: "50.99", r: "4.73" },
          }),
        ]),
        _vm._v(" "),
        _c("clipPath", { attrs: { id: "clippath-8" } }, [
          _c("circle", {
            staticClass: "blog-cls-1",
            attrs: { cx: "100.2", cy: "54.71", r: "3.65" },
          }),
        ]),
        _vm._v(" "),
        _c("clipPath", { attrs: { id: "clippath-9" } }, [
          _c("circle", {
            staticClass: "blog-cls-1",
            attrs: { cx: "91.25", cy: "57.16", r: "2.9" },
          }),
        ]),
      ]),
      _vm._v(" "),
      _c("circle", {
        staticStyle: { fill: "#9acbdf" },
        attrs: { cx: "59.66", cy: "59.88", r: "55" },
      }),
      _vm._v(" "),
      _c("path", {
        staticStyle: { fill: "#66b2d0" },
        attrs: {
          d:
            "M116.9 59.09c1.67.93 1.67 2.53 0 3.46L63.12 93.61c-1.67.93-4.32.93-5.99 0L2.48 62.17c-1.67-.93-1.67-2.53 0-3.46l53.78-31.05c1.67-.93 4.32-.93 5.99 0l54.65 31.43Z",
        },
      }),
      _vm._v(" "),
      _c("path", {
        staticClass: "blog-cls-3",
        attrs: {
          d:
            "M1.24 60.68v-.23.23ZM117.21 62.33c-.08.05-.16.1-.25.15v.02s-.04.03-.06.04L63.18 93.6c-.43.25-.86.37-1.3.49v.02s-.04.01-.06.02v-.04c-.68.19-1.48.25-2.28.19-.2-.01-.41-.04-.61-.08l-.17-.03c-.1-.02-.2-.04-.29-.07-.47-.12-.9-.29-1.28-.5v.03l-.06-.03L2.48 62.17c-.19-.1-.36-.21-.51-.33-.18-.15-.34-.32-.46-.48-.15-.22-.24-.45-.26-.68v.16a1.32 1.32 0 0 1-.06-.39v6.48c0 .68.43 1.3 1.24 1.73v-.04.1l54.71 31.37c.68.37 1.54.62 2.41.68.32.03.65.03.98 0h.1c.04 0 .09 0 .13-.01.39-.03.77-.09 1.14-.18.49-.12.93-.25 1.3-.49v-.04l53.72-31.02c.45-.27.77-.59.98-.92.01-.02.02-.03.03-.05.02-.03.04-.06.05-.09.08-.14.14-.28.17-.42v-6.73c0 .53-.32 1.06-.93 1.52Z",
        },
      }),
      _vm._v(" "),
      _c("path", {
        staticClass: "blog-cls-3",
        attrs: {
          d:
            "m68.81 48.81-10.82 4.02-.11 21.92.57 9.02 34.09-20.9V34.93L68.81 48.81z",
        },
      }),
      _vm._v(" "),
      _c("path", {
        staticStyle: { fill: "#077eb0" },
        attrs: {
          d:
            "M53.45 49.73 43.07 37.38l-14.11 4.43v26.43l29.49 15.53-.46-28.64-4.54-5.4z",
        },
      }),
      _vm._v(" "),
      _c("path", {
        staticStyle: { fill: "#dcdcdc" },
        attrs: {
          d:
            "M94.37 32.4 57.99 52.83l-14.8-16.96 35.37-21.05.01-.01.65-.21 15.15 17.8z",
        },
      }),
      _vm._v(" "),
      _c("path", {
        staticStyle: { fill: "#bababa" },
        attrs: {
          d:
            "M78.56 14.82 43.19 35.87l-15.62 4.27 20-11.52 15.36-8.84 15.63-4.96z",
        },
      }),
      _vm._v(" "),
      _c("path", {
        staticClass: "blog-cls-8",
        attrs: {
          d:
            "M67.63 58.21v10.14l8.03-5.07v-9.95l-8.03 4.88zM78.29 52.14v10.15l8.02-5.07v-10.6l-8.02 5.52zM34.99 46.75v15.81l6.28 3.69-.06-16.39-6.22-3.11zM46.14 51.85v15.81l6.28 3.69-.07-16.39-6.21-3.11z",
        },
      }),
      _vm._v(" "),
      _c("path", {
        staticStyle: { fill: "#7f7f7f" },
        attrs: {
          d:
            "M94.37 32.4v1.5l-1.83 1.03-23.73 13.88-10.82 6.32-1.93-2.3-2.61-3.1-10.38-12.35-14.11 4.43-1.49-1.6.1-.07 15.62-4.27 14.8 16.96L94.37 32.4z",
        },
      }),
      _vm._v(" "),
      _c("path", {
        staticClass: "blog-cls-12",
        attrs: {
          d:
            "m79.24 18.53-5.74 3.32c-.62.36-.77 1.18-.31 1.73l8.77 10.6c.36.44.99.55 1.48.25l5.73-3.3c.62-.36.77-1.18.31-1.73L80.7 18.79c-.36-.43-.98-.54-1.46-.26ZM70.87 23.1l-5.74 3.32c-.62.36-.77 1.18-.31 1.73l8.77 10.6c.36.44.99.55 1.48.25l5.73-3.3c.62-.36.77-1.18.31-1.73l-8.78-10.61c-.36-.43-.98-.54-1.46-.26ZM62.5 27.79l-5.74 3.32c-.62.36-.77 1.18-.31 1.73l8.77 10.6c.36.44.99.55 1.48.25l5.73-3.3c.62-.36.77-1.18.31-1.73l-8.78-10.61c-.36-.43-.98-.54-1.46-.26ZM54.12 32.74l-5.74 3.32c-.62.36-.77 1.18-.31 1.73l8.77 10.6c.36.44.99.55 1.48.25l5.73-3.3c.62-.36.77-1.18.31-1.73L55.58 33c-.36-.43-.98-.54-1.46-.26Z",
        },
      }),
      _vm._v(" "),
      _c("g", [
        _c("path", {
          staticClass: "blog-cls-13",
          attrs: {
            d:
              "M24.73 57.84c0-.63.69-.76.95-.76s.95.13.95.76v10.9H24.8v-10.4c-.06-.06-.06-.44-.06-.5Z",
          },
        }),
        _vm._v(" "),
        _c("circle", {
          staticClass: "blog-cls-7",
          attrs: { cx: "25.61", cy: "54.57", r: "4.73" },
        }),
        _vm._v(" "),
        _c("circle", {
          staticClass: "blog-cls-14",
          staticStyle: { "clip-path": "url(#clippath-4)" },
          attrs: { cx: "24.67", cy: "53.75", r: "4.73" },
        }),
        _vm._v(" "),
        _c("path", {
          staticClass: "blog-cls-2",
          attrs: {
            d: "M24.73 64.65s-2.77.13-3.15-1.83M26.56 63.26s3.65.19 3.97-2.77",
          },
        }),
        _vm._v(" "),
        _c("circle", {
          staticClass: "blog-cls-7",
          attrs: { cx: "30.52", cy: "58.28", r: "3.65" },
        }),
        _vm._v(" "),
        _c("circle", {
          staticClass: "blog-cls-14",
          staticStyle: { "clip-path": "url(#clippath-5)" },
          attrs: { cx: "29.77", cy: "57.65", r: "3.65" },
        }),
        _vm._v(" "),
        _c("circle", {
          staticClass: "blog-cls-7",
          attrs: { cx: "21.58", cy: "60.74", r: "2.9" },
        }),
        _vm._v(" "),
        _c("circle", {
          staticClass: "blog-cls-14",
          staticStyle: { "clip-path": "url(#clippath-6)" },
          attrs: { cx: "20.95", cy: "60.3", r: "2.9" },
        }),
        _vm._v(" "),
        _c("ellipse", {
          staticClass: "blog-cls-13",
          attrs: { cx: "25.71", cy: "68.74", rx: ".91", ry: ".38" },
        }),
      ]),
      _vm._v(" "),
      _c("g", [
        _c("path", {
          staticClass: "blog-cls-13",
          attrs: {
            d:
              "M94.4 54.27c0-.63.69-.76.95-.76s.95.13.95.76v10.9h-1.83v-10.4c-.06-.06-.06-.44-.06-.5Z",
          },
        }),
        _vm._v(" "),
        _c("circle", {
          staticClass: "blog-cls-7",
          attrs: { cx: "95.29", cy: "50.99", r: "4.73" },
        }),
        _vm._v(" "),
        _c("circle", {
          staticClass: "blog-cls-14",
          staticStyle: { "clip-path": "url(#clippath-7)" },
          attrs: { cx: "94.34", cy: "50.17", r: "4.73" },
        }),
        _vm._v(" "),
        _c("path", {
          staticClass: "blog-cls-2",
          attrs: {
            d: "M94.4 61.07s-2.77.13-3.15-1.83M96.23 59.68s3.65.19 3.97-2.77",
          },
        }),
        _vm._v(" "),
        _c("circle", {
          staticClass: "blog-cls-7",
          attrs: { cx: "100.2", cy: "54.71", r: "3.65" },
        }),
        _vm._v(" "),
        _c("circle", {
          staticClass: "blog-cls-14",
          staticStyle: { "clip-path": "url(#clippath-8)" },
          attrs: { cx: "99.44", cy: "54.08", r: "3.65" },
        }),
        _vm._v(" "),
        _c("circle", {
          staticClass: "blog-cls-7",
          attrs: { cx: "91.25", cy: "57.16", r: "2.9" },
        }),
        _vm._v(" "),
        _c("circle", {
          staticClass: "blog-cls-14",
          staticStyle: { "clip-path": "url(#clippath-9)" },
          attrs: { cx: "90.62", cy: "56.72", r: "2.9" },
        }),
        _vm._v(" "),
        _c("ellipse", {
          staticClass: "blog-cls-13",
          attrs: { cx: "95.38", cy: "65.16", rx: ".91", ry: ".38" },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }